import classNames from 'classnames';
import {useState} from 'react';

import {Section, SECTION_STYLES} from '@/components/common/section/Section';
import type {Period} from '@/components/common/tariffs/interfaces';

import tariffsStyles from '../../../../pages/tariffs/tariffs-variables.module.css';
import {PERIOD_VALUES} from '../../tariffs/tariffs-info/components/controllers/const';
import {TariffsInfo} from '../../tariffs/tariffs-info/TariffsInfo';
import styles from './TariffsCalc.module.css';

export function TariffsCalc() {
	const [users, setUsers] = useState<number>(10);
	const [periodValue, setPeriodValue] = useState<Period>(PERIOD_VALUES[0].value);

	return (
		<Section
			sectionId="tariffs-calc"
			style={SECTION_STYLES.PRIMARY}
			className={classNames(styles.root, tariffsStyles.cssLocalVariables)}
		>
			<TariffsInfo
				periodValue={periodValue}
				users={users}
				setPeriodValue={setPeriodValue}
				setUsers={setUsers}
			/>
		</Section>
	);
}
